export default {
  '/metadataCollect/getAppName': {
    method: 'post',
    reply: 200,
    data: {
      status: '0',
      msg: 'success',
      data: [
        ' SAP-HANA',
        '24/7 Online Self-Service FS-CN',
        '2B-AUTH',
        '3D Computer Vision Measurement System',
        '3rd party Invoice Inssuance Platform',
        '3rd party Invoice Receipt Platform',
        '55555.bba',
        'A-DAM',
        'A2I',
        'AAA Application',
        'ABATech',
        'ABN FS-CN',
        'ABS Suite AFC FS-CN',
        'ACS FS-CN',
        'AD/ADFS',
        'ADD',
        'ADDM',
        'AFE',
        'AFO180',
        'AFS Online Project Management Platform',
        'AFS service offer platform',
        'AGF Digital Workplace',
        'AGF Kanban Next',
        'AGV for WHS DP to TBLS',
        'AGV system  for Tiexi Plant Front Window line suppliment process Application Server',
        'AGVS',
        'AGV_LK BIW From GR to LK Local floor',
        'AGV_LK Sorting To LU CB',
        'AI Chatbot HIL FS-CN',
        'AI Platform',
        'AI Vision Detecion',
        'AIQX',
        'ALFI-system',
        'ALM',
        'ALPAC',
        'ALS (Powertrain)',
        'ALSVM',
        'AMA',
        'AMARETO',
        'AML Monitoring System AFC&HIL FS-CN',
        'AMphyBE',
        'ANSA',
        'APDM',
        'APDM (Dadong)',
        'APDM (Lydia)',
        'APDM (Tiexi)',
        'API Automation & Orchestration',
        'API Gateway',
        'API Portal',
        'API-STORE',
        'APP Tracking',
        'AQM.Next',
        'AQM2 Lydia',
        'AQM2 Tiexi',
        'AR Remote Collaboration',
        'ARAS Innovator',
        'ASBC-PKI (Dadong)',
        'ASBC-PKI (Lydia)',
        'ASBC-PKI (Tiexi)',
        'ASCC PO Price Backdating',
        'ASCENT@BMW',
        'ASM',
        'ATC Confluence',
        'ATC Jira',
        'ATC- AATF',
        'ATG',
        'AUTODESK VRED Professional',
        'AVL Calgas',
        'AW Browser',
        'AW Content Locker',
        'AW agent',
        'AXDB',
        'Abaqus',
        'Abnormal Behavious Monitor for PEG',
        'Acronis',
        'Activity Plan !',
        'Adams CAR/AT',
        'Add Partner',
        'Advanced Campaign Tool AFC&HIL FS-CN',
        'Aftersales COR',
        'Aftersales Dealer Backend system',
        'Aftersales Online Training App',
        'Aftersales Warranty Assistant',
        'Agile Toolchain Data Service',
        'Agile Tools Portal',
        'Air Watch',
        'AirWatch EMM Platform',
        'AlertNow (Dadong)',
        'AlertNow (Lydia)',
        'AlertNow (Tiexi)',
        'All Star Lounge',
        'Analyser For Tail Gas',
        'Animator',
        'Ansible',
        'Ansible Tower',
        'Ansys Workbench',
        'Anti-Fraud 2 AFC&HIL FS-CN',
        'Anvil',
        'Apache',
        'Aplaus BBA',
      ],
    },
  },
  '/metadataCollect/getDataBaseType': {
    method: 'post',
    data: {
      status: '0',
      msg: 'success',
      data: [
        {
          code: 'mysql',
          versions: ['9.x', '10.x', '11.x', '12.x', '13.x', '14.x'],
          desc: 'MySQL',
        },
        {
          code: 'oracle',
          versions: ['Oracle 10g'],
          desc: 'Oracle',
        },
        {
          code: 'postgresql',
          versions: ['5.5', '5.6', '5.7', '8.0'],
          desc: 'PostgreSQL',
        },
        {
          code: 'sqlserver',
          versions: [
            'SQL Server 2012',
            'SQL Server 2014',
            'SQL Server 2016',
            'SQL Server 2017',
            'SQL Server 2019',
            'SQL Server 2022',
          ],
          desc: 'SQL Server',
        },
      ],
    },
  },
  '/metadataCollect/workSpaceList': {
    method: 'post',
    data: {
      status: '0',
      msg: 'success',
      data: {
        records: [
          {
            idStr: 'DSC00005',
            id: 5,
            datasourceName: 'datasource1',
            appId: 'APP-02634',
            appName: 'API Portal',
            databaseName: 'test3',
            databaseType: 'mysql',
            createUserName: 'BBAProduction TEST500927, BBA',
            options: ['Detail', 'Edit', 'Delete', 'Collection Records'],
          },
          {
            idStr: 'DSC00004',
            id: 4,
            datasourceName: 'datasource1',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            databaseName: 'test2',
            databaseType: 'mysql',
            createUserName: 'BBAProduction TEST500927, BBA',
            options: ['Detail', 'Edit', 'Delete', 'Collection Records'],
          },
          {
            idStr: 'DSC00003',
            id: 3,
            datasourceName: 'datasource1',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            databaseName: 'test1',
            databaseType: 'mysql',
            createUserName: 'BBAProduction TEST500927, BBA',
            options: ['Detail', 'Edit', 'Delete', 'Collection Records'],
          },
        ],
        total: 3,
        size: 100,
        current: 1,
      },
    },
  },
  '/metadataCollect/getDataSourceName': {
    method: 'post',
    data: {
      status: '0',
      msg: 'success',
      data: ['datasource1', 'datasource2', 'datasource3'],
    },
  },
  '/metadataCollect/getStatus': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: {
        status: [
          {
            code: 'success',
            desc: 'Success',
          },
          {
            code: 'failed',
            desc: 'Failed',
          },
        ],
      },
    },
  },
  '/metadataCollect/collectRecord/workSpaceList': {
    method: 'post',
    data: {
      status: '0',
      msg: 'success',
      data: {
        records: [
          {
            idStr: 'DCR00026',
            id: 26,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-17 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00025',
            id: 25,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-17 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00024',
            id: 24,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-10 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00023',
            id: 23,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-10 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00014',
            id: 14,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-03 12:29:46',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00012',
            id: 12,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-03 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00011',
            id: 11,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-04-03 02:40:00',
            responsibleUsers: null,
          },
          {
            idStr: 'DCR00009',
            id: 9,
            datasourceName: 'edm-test',
            appId: 'APP-03270',
            appName: 'Enterprise Data Map',
            status: 'failed',
            statusStr: 'FAILED',
            intervalType: 'week',
            createTime: '2023-03-27 17:18:18',
            responsibleUsers: null,
          },
        ],
        total: 8,
        size: 100,
        current: 1,
      },
    },
  },
  '/metadataCollect/getOptions': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: {
        databaseType: [
          {
            code: 'mysql',
            versions: ['9.x', '10.x', '11.x', '12.x', '13.x', '14.x'],
            desc: 'MySQL',
          },
          {
            code: 'oracle',
            versions: ['Oracle 10g'],
            desc: 'Oracle',
          },
          {
            code: 'postgresql',
            versions: ['5.5', '5.6', '5.7', '8.0'],
            desc: 'PostgreSQL',
          },
          {
            code: 'sqlserver',
            versions: [
              'SQL Server 2012',
              'SQL Server 2014',
              'SQL Server 2016',
              'SQL Server 2017',
              'SQL Server 2019',
              'SQL Server 2022',
            ],
            desc: 'SQL Server',
          },
        ],
        intervalType: [
          {
            code: 'daily',
            desc: '每天',
          },
          {
            code: 'week',
            desc: '每周',
          },
          {
            code: 'month',
            desc: '每月',
          },
        ],
        connectionType: [
          {
            code: 'api',
            desc: 'API',
          },
        ],
      },
    },
  },
  '/metadataCollect/getAppIdAndPrime': {
    method: 'post',
    data: (params: any) => {
      let res = ['APP1', 'APP2', 'APP3', 'APP4'];
      try {
        params = JSON.parse(params.data || {});
      } catch (e) {
        //
      }

      res = res.filter((it) => it.indexOf(params.fuzzySearch) > -1);
      return [
        200,
        {
          status: '0',
          msg: 'success',
          data: res,
        },
      ];
    },
  },

  '/metadataCollect/getConnectionType': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: ['connectionType1', 'connectionType2', 'connectionType3', 'connectionType4'],
    },
  },

  '/metadataCollect/editDataSource': {
    method: 'post',
    data: {
      status: '500',
      msg: 'success',
      data: null,
    },
  },
  '/metadataCollect/detail/*': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: {
        idStr: 'DSC00003',
        id: 3,
        datasourceName: 'datasource1',
        appId: 'APP1',
        appName: null,
        databaseName: 'test1',
        databaseType: 'mysql',
        databaseVersion: '9.x',
        createUserName: null,
        createUser: 'U0500927',
        intervalType: 'week',
        dispatchInterval: 1,
        expectedTime: '2023-04-21 02:00:00',
        responsibleUsers: ['xianlei.nai@lingyue-digital.com'],
        description: null,
        options: null,
        connectionType: 'connectionType1',
      },
    },
  },

  '/metadataCollect/delete/*': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: null,
    },
  },

  '/metadataCollect/collectRecord/isPopUpReminds': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: true,
    },
  },

  '/metadataCollect/collectRecord/closeRemind': {
    method: 'get',
    data: {
      status: '0',
      msg: 'success',
      data: true,
    },
  },
};
